/**
 * Created by bszggg on 2019. 06. 14..
 */


const Api = {
  // apiUrl: "http://api.bpapi.hu/api_utc/apibp_frontend/",// LOCAL
  apiUrl: "https://api.brightparrots.com/api_utc/apibp_selling/", // Ez az API-val bővített


  // apiUrl: "http://api.brightparrots.com/apibp_frontend/", // Ez az alap backend a szerveren
  // apiUrl: "http://localhost/bp_backend/public/apibp_frontend/",
  // apiUrl: "http://api.bpapi.hu/apibp_frontend/",
  // apiUrl: "http://localhost/!_sct/slim-cors-test/web/public/",
  // apiUrl: "http://localhost/!_sct/slim-cors-test/web/public/apibp_frontend/",
  // apiUrl: "http://localhost/!_aa/slim-cors-test/web/public/cors-proba",
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  },

  // TODO -- Ide kell egy filebeolvasás a root-ból, és abban lenne az api url.

  getBodyWithToken: function (data) {
    if (typeof data === "undefined" || data === null) {
      data = {};
    }
    // if (localStorage.token) {
    //   data.Token = localStorage.token;
    // }
    if (localStorage.getItem("tokenSelling")) {
      data.Token = localStorage.getItem("tokenSelling");
    }
    if (localStorage.getItem("browserIdentifier")) {
      data.browserIdentifier = localStorage.getItem("browserIdentifier");
    }
    return data;
  },

  healthCheck: function (data) {
    const bodyData = this.getBodyWithToken(data);
    const syncUrl = "healthCheck";
    return new Promise(function (resolve, reject) {
      bodyData.random = Math.random();
      fetch(Api.apiUrl + syncUrl, {
        body: JSON.stringify(bodyData),
        method: 'POST',
        headers: Api.headers,
      }).then(res => {
        return res.json()
      })
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
          console.error('Error:', error)
        });
    });
  },

  getLoginCompanies: function (data) {
    const bodyData = this.getBodyWithToken(data);
    const syncUrl = "getLoginCompanies";
    return new Promise(function (resolve, reject) {
      bodyData.random = Math.random();
      fetch(Api.apiUrl + syncUrl, {
        body: JSON.stringify(bodyData),
        method: 'POST',
        headers: Api.headers,
      }).then(res => {
        return res.json()
      })
        .then(res => {
          resolve(res);

        })
        .catch(error => {
          reject(error);
          console.error('Error:', error)
        });
    });
  },


  loginCreate: function (data) {
    const bodyData = this.getBodyWithToken(data);
    const syncUrl = "loginCreate";
    return new Promise(function (resolve, reject) {
      bodyData.random = Math.random();
      fetch(Api.apiUrl + syncUrl, {
        body: JSON.stringify(bodyData),
        method: 'POST',
        headers: Api.headers,
      }).then(res => {
        // console.log(res)
        // res.text().then(function (text) {
        //   console.log(text)
        // });
        return res.json()
      })
        .then(res => {
          resolve(res);

        })
        .catch(error => {
          reject(error);
          console.error('Error:', error)
        });
    });
  },

  logout: function (data) {
    const bodyData = this.getBodyWithToken(data);
    const syncUrl = "logout";
    return new Promise(function (resolve, reject) {
      bodyData.random = Math.random();
      fetch(Api.apiUrl + syncUrl, {
        body: JSON.stringify(bodyData),
        method: 'POST',
        headers: Api.headers,
      }).then(res => {
        return res.json()
      })
        .then(res => {
          resolve(res);

        })
        .catch(error => {
          reject(error);
          console.error('Error:', error)
        });
    });
  },


  /* *********************** Selling START *********************** */
  getDiscountChooses: function (data) {
    const bodyData = this.getBodyWithToken(data);
    const syncUrl = "getDiscountChooses";
    return new Promise(function (resolve, reject) {
      bodyData.random = Math.random();
      console.log("getDiscountChooses:bodyData")
      console.log(bodyData)
      fetch(Api.apiUrl + syncUrl, {
        body: JSON.stringify(bodyData),
        method: 'POST',
        headers: Api.headers,
      }).then(res => {
        // res.text().then(function(ret){
        //   console.log("getDiscountChooses:result")
        //   console.log(ret)
        // })
        return res.json()
      })
        .then(res => {
          resolve(res);

        })
        .catch(error => {
          reject(error);
          console.error('Error:', error)
        });
    });
  },

  /* *********************** Selling END *********************** */

  //
  // // USER
  // getUsers: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getUsers";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  //
  // getUser: function (id) {
  //   const data = {
  //     id: id, data: Math.random()
  //   };
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getUser";
  //   return new Promise(function (resolve, reject) {
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // saveUser: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "saveUser";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getPartnerUsers: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getPartnerUsers";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  //
  // getPartnerUser: function (id) {
  //   const data = {
  //     id: id, data: Math.random()
  //   };
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getPartnerUser";
  //   return new Promise(function (resolve, reject) {
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // savePartnerUser: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "savePartnerUser";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  //
  //
  // // getDiscountChooses: function (data) {
  // //   const bodyData = this.getBodyWithToken(data);
  // //   const syncUrl = "getDiscountChooses";
  // //   return new Promise(function (resolve, reject) {
  // //     bodyData.random = Math.random();
  // //     fetch(Api.apiUrl + syncUrl, {
  // //       body: JSON.stringify(bodyData),
  // //       method: 'POST',
  // //       headers: Api.headers,
  // //     }).then(res => res.json())
  // //       .then(res => {
  // //         resolve(res);
  // //
  // //       })
  // //       .catch(error => {
  // //         reject(error);
  // //         console.error('Error:', error)
  // //       });
  // //   });
  // // },
  //
  // getDiscountChoose: function (id) {
  //   const data = {
  //     id: id, data: Math.random()
  //   };
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getDiscountChoose";
  //   return new Promise(function (resolve, reject) {
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // saveDiscountChoose: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "saveDiscountChoose";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  //
  // getMyUser: function (id) {
  //   const data = {
  //     id: id, data: Math.random()
  //   };
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getMyUser";
  //   return new Promise(function (resolve, reject) {
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // saveMyUser: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "saveMyUser";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  //
  // // ELEMENT
  // getElements: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getElements";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getElement: function (id) {
  //   const data = {
  //     id: id, data: Math.random()
  //   };
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getElement";
  //   return new Promise(function (resolve, reject) {
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // saveElement: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "saveElement";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // generateElementBarCode: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "generateElementBarCode";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // assembleElement: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "assembleElement";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // disassembleElement: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "disassembleElement";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  //
  // // Stores
  // getStores: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getStores";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getStore: function (id) {
  //   const data = {
  //     id: id, data: Math.random()
  //   };
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getStore";
  //   return new Promise(function (resolve, reject) {
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // saveStore: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "saveStore";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  //
  // BusinessPartners
  getBusinessPartners: function (data) {
    const bodyData = this.getBodyWithToken(data);
    const syncUrl = "getBusinessPartners";
    return new Promise(function (resolve, reject) {
      bodyData.random = Math.random();
      fetch(Api.apiUrl + syncUrl, {
        body: JSON.stringify(bodyData),
        method: 'POST',
        headers: Api.headers,
      }).then(res => res.json())
        .then(res => {
          resolve(res);

        })
        .catch(error => {
          reject(error);
          console.error('Error:', error)
        });
    });
  },
  getBusinessPartner: function (id) {
    const data = {
      id: id, data: Math.random()
    };
    const bodyData = this.getBodyWithToken(data);
    const syncUrl = "getBusinessPartner";
    return new Promise(function (resolve, reject) {
      fetch(Api.apiUrl + syncUrl, {
        body: JSON.stringify(bodyData),
        method: 'POST',
        headers: Api.headers
      }).then(res => res.json())
        .then(res => {
          resolve(res);

        })
        .catch(error => {
          reject(error);
          console.error('Error:', error)
        });
    });
  },
  getBusinessPartnerByTaxnumber: function (id) {
    const data = {
      id: id, data: Math.random()
    };
    const bodyData = this.getBodyWithToken(data);
    const syncUrl = "getBusinessPartnerByTaxnumber";
    return new Promise(function (resolve, reject) {
      fetch(Api.apiUrl + syncUrl, {
        body: JSON.stringify(bodyData),
        method: 'POST',
        headers: Api.headers
      }).then(res => res.json())
        .then(res => {
          resolve(res);

        })
        .catch(error => {
          reject(error);
          console.error('Error:', error)
        });
    });
  },
  saveBusinessPartner: function (data) {
    const bodyData = this.getBodyWithToken(data);
    const syncUrl = "saveBusinessPartner";
    return new Promise(function (resolve, reject) {
      bodyData.random = Math.random();
      fetch(Api.apiUrl + syncUrl, {
        body: JSON.stringify(bodyData),
        method: 'POST',
        headers: Api.headers,
      }).then(res => res.json())
        .then(res => {
          resolve(res);

        })
        .catch(error => {
          reject(error);
          console.error('Error:', error)
        });
    });
  },
  getBuyer: function (data) {
    const bodyData = this.getBodyWithToken(data);
    const syncUrl = "getBuyer";
    return new Promise(function (resolve, reject) {
      bodyData.random = Math.random();
      fetch(Api.apiUrl + syncUrl, {
        body: JSON.stringify(bodyData),
        method: 'POST',
        headers: Api.headers,
      }).then(res => res.json())
        .then(res => {
          resolve(res);

        })
        .catch(error => {
          reject(error);
          console.error('Error:', error)
        });
    });
  },

  getBuyerBySid: function (data) {
    const bodyData = this.getBodyWithToken(data);
    const syncUrl = "getBuyerBySid";
    return new Promise(function (resolve, reject) {
      bodyData.random = Math.random();
      fetch(Api.apiUrl + syncUrl, {
        body: JSON.stringify(bodyData),
        method: 'POST',
        headers: Api.headers,
      }).then(res => res.json())
        .then(res => {
          resolve(res);

        })
        .catch(error => {
          reject(error);
          console.error('Error:', error)
        });
    });
  },
  saveBuyer: function (data) {
    const bodyData = this.getBodyWithToken(data);
    const syncUrl = "saveBuyer";
    return new Promise(function (resolve, reject) {
      bodyData.random = Math.random();
      fetch(Api.apiUrl + syncUrl, {
        body: JSON.stringify(bodyData),
        method: 'POST',
        headers: Api.headers,
      }).then(res => res.json())
        .then(res => {
          resolve(res);

        })
        .catch(error => {
          reject(error);
          console.error('Error:', error)
        });
    });
  },
  getElement: function (data) {
    const bodyData = this.getBodyWithToken(data);
    const syncUrl = "getElement";
    return new Promise(function (resolve, reject) {
      bodyData.random = Math.random();
      fetch(Api.apiUrl + syncUrl, {
        body: JSON.stringify(bodyData),
        method: 'POST',
        headers: Api.headers,
      }).then(res => res.json())
        .then(res => {
          resolve(res);

        })
        .catch(error => {
          reject(error);
          console.error('Error:', error)
        });
    });
  },
  getElement: function (data) {
    const bodyData = this.getBodyWithToken(data);
    const syncUrl = "getElement";
    return new Promise(function (resolve, reject) {
      bodyData.random = Math.random();
      fetch(Api.apiUrl + syncUrl, {
        body: JSON.stringify(bodyData),
        method: 'POST',
        headers: Api.headers,
      }).then(res => res.json())
        .then(res => {
          resolve(res);

        })
        .catch(error => {
          reject(error);
          console.error('Error:', error)
        });
    });
  },
  getElementByBarcode: function (data) {
    const bodyData = this.getBodyWithToken(data);
    const syncUrl = "getElementByBarcode";
    return new Promise(function (resolve, reject) {
      bodyData.random = Math.random();
      fetch(Api.apiUrl + syncUrl, {
        body: JSON.stringify(bodyData),
        method: 'POST',
        headers: Api.headers,
      }).then(res => res.json())
        .then(res => {
          resolve(res);

        })
        .catch(error => {
          reject(error);
          console.error('Error:', error)
        });
    });
  },
  getElementsByCategorySyncPk: function (data) {
    const bodyData = this.getBodyWithToken(data);
    const syncUrl = "getElementsByCategorySyncPk";
    bodyData.querySamp = new Date();
    if (!Api.syncElementQueryContainer) {
      Api.syncElementQueryContainer = [];
    }
    Api.syncElementQueryContainer.push({"querySamp": bodyData.querySamp});
    return new Promise(function (resolve, reject) {
      bodyData.random = Math.random();
      fetch(Api.apiUrl + syncUrl, {
        body: JSON.stringify(bodyData),
        method: 'POST',
        headers: Api.headers,
      }).then(res => res.json())
        .then(res => {
          if (Array.isArray(Api.syncElementQueryContainer)) {
            let isLaterQuery = false;
            Array.prototype.forEach.call(Api.syncElementQueryContainer, function (e) {
              if (e.querySamp > bodyData.querySamp) {
                isLaterQuery = true;
              }
            });
            // remove the oldeies
            const oldDate = new Date(new Date().getTime() - 6000);
            Array.prototype.forEach.call(Api.syncElementQueryContainer, function (e,i) {
              if (e.querySamp < oldDate) {
                delete Api.syncElementQueryContainer[i];
              }
            });
            if (isLaterQuery) {
              reject({"isLaterQuery": true});
            } else {
              resolve(res);
            }
          } else {
            resolve(res);
          }
        })
        .catch(error => {
          reject(error);
          console.error('Error:', error)
        });
    });
  },
  getElementCategories: function (data) {
    const bodyData = this.getBodyWithToken(data);
    const syncUrl = "getElementCategories";
    return new Promise(function (resolve, reject) {
      bodyData.random = Math.random();
      fetch(Api.apiUrl + syncUrl, {
        body: JSON.stringify(bodyData),
        method: 'POST',
        headers: Api.headers,
      }).then(res => res.json())
        .then(res => {
          resolve(res);

        })
        .catch(error => {
          reject(error);
          console.error('Error:', error)
        });
    });
  },
  getCompanyData: function (data) {
    const bodyData = this.getBodyWithToken(data);
    const syncUrl = "getCompanyData";
    return new Promise(function (resolve, reject) {
      bodyData.random = Math.random();
      fetch(Api.apiUrl + syncUrl, {
        body: JSON.stringify(bodyData),
        method: 'POST',
        headers: Api.headers,
      }).then(res => res.json())
        .then(res => {
          resolve(res);

        })
        .catch(error => {
          reject(error);
          console.error('Error:', error)
        });
    });
  },
  getContents: function (data) {
    const bodyData = this.getBodyWithToken(data);
    const syncUrl = "getContents";
    return new Promise(function (resolve, reject) {
      bodyData.random = Math.random();
      fetch(Api.apiUrl + syncUrl, {
        body: JSON.stringify(bodyData),
        method: 'POST',
        headers: Api.headers,
      }).then(res => res.json())
        .then(res => {
          resolve(res);

        })
        .catch(error => {
          reject(error);
          console.error('Error:', error)
        });
    });
  },
  getStores: function (data) {
    const bodyData = this.getBodyWithToken(data);
    const syncUrl = "getStores";
    return new Promise(function (resolve, reject) {
      bodyData.random = Math.random();
      fetch(Api.apiUrl + syncUrl, {
        body: JSON.stringify(bodyData),
        method: 'POST',
        headers: Api.headers,
      }).then(res => res.json())
        .then(res => {
          resolve(res);

        })
        .catch(error => {
          reject(error);
          console.error('Error:', error)
        });
    });
  },
  getStore: function (data) {
    const bodyData = this.getBodyWithToken(data);
    const syncUrl = "getStore";
    return new Promise(function (resolve, reject) {
      bodyData.random = Math.random();
      fetch(Api.apiUrl + syncUrl, {
        body: JSON.stringify(bodyData),
        method: 'POST',
        headers: Api.headers,
      }).then(res => res.json())
        .then(res => {
          resolve(res);

        })
        .catch(error => {
          reject(error);
          console.error('Error:', error)
        });
    });
  },
  saveStoreAndMakeWorkstation: function (data) {
    const bodyData = this.getBodyWithToken(data);
    const syncUrl = "saveStoreAndMakeWorkstation";
    return new Promise(function (resolve, reject) {
      bodyData.random = Math.random();
      fetch(Api.apiUrl + syncUrl, {
        body: JSON.stringify(bodyData),
        method: 'POST',
        headers: Api.headers,
      }).then(res => res.json())
        .then(res => {
          resolve(res);

        })
        .catch(error => {
          reject(error);
          console.error('Error:', error)
        });
    });
  },
  addSell: function (data) {
    const bodyData = this.getBodyWithToken(data);
    const syncUrl = "addSell";
    return new Promise(function (resolve, reject) {
      bodyData.random = Math.random();
      fetch(Api.apiUrl + syncUrl, {
        body: JSON.stringify(bodyData),
        method: 'POST',
        headers: Api.headers,
      }).then(res => res.json())
        .then(res => {
          resolve(res);

        })
        .catch(error => {
          reject(error);
          console.error('Error:', error)
        });
    });
  },
  getSell: function (data) {
    const bodyData = this.getBodyWithToken(data);
    const syncUrl = "getSell";
    return new Promise(function (resolve, reject) {
      bodyData.random = Math.random();
      fetch(Api.apiUrl + syncUrl, {
        body: JSON.stringify(bodyData),
        method: 'POST',
        headers: Api.headers,
      }).then(res => res.json())
        .then(res => {
          resolve(res);

        })
        .catch(error => {
          reject(error);
          console.error('Error:', error)
        });
    });
  },
  getSettings: function (data) {
    const bodyData = this.getBodyWithToken(data);
    const syncUrl = "getSettings";
    return new Promise(function (resolve, reject) {
      bodyData.random = Math.random();
      fetch(Api.apiUrl + syncUrl, {
        body: JSON.stringify(bodyData),
        method: 'POST',
        headers: Api.headers,
      }).then(res => res.json())
        .then(res => {
          resolve(res);

        })
        .catch(error => {
          reject(error);
          console.error('Error:', error)
        });
    });
  },
  getDataBySid: function (data) {
    const bodyData = this.getBodyWithToken(data);
    const syncUrl = "getDataBySid";
    return new Promise(function (resolve, reject) {
      bodyData.random = Math.random();
      fetch(Api.apiUrl + syncUrl, {
        body: JSON.stringify(bodyData),
        method: 'POST',
        headers: Api.headers,
      }).then(res => res.json())
        .then(res => {
          resolve(res);

        })
        .catch(error => {
          reject(error);
          console.error('Error:', error)
        });
    });
  },
  getCloses: function (data) {
    const bodyData = this.getBodyWithToken(data);
    const syncUrl = "getCloses";
    return new Promise(function (resolve, reject) {
      bodyData.random = Math.random();
      fetch(Api.apiUrl + syncUrl, {
        body: JSON.stringify(bodyData),
        method: 'POST',
        headers: Api.headers,
      }).then(res => res.json())
        .then(res => {
          resolve(res);

        })
        .catch(error => {
          reject(error);
          console.error('Error:', error)
        });
    });
  },
  addTransaction: function (data) {
    const bodyData = this.getBodyWithToken(data);
    const syncUrl = "addTransaction";
    return new Promise(function (resolve, reject) {
      bodyData.random = Math.random();
      fetch(Api.apiUrl + syncUrl, {
        body: JSON.stringify(bodyData),
        method: 'POST',
        headers: Api.headers,
      }).then(res => res.json())
        .then(res => {
          resolve(res);

        })
        .catch(error => {
          reject(error);
          console.error('Error:', error)
        });
    });
  },
  getIntegrationConnection: function (data) {
    const bodyData = this.getBodyWithToken(data);
    const syncUrl = "getIntegrationConnection";
    return new Promise(function (resolve, reject) {
      bodyData.random = Math.random();
      fetch(Api.apiUrl + syncUrl, {
        body: JSON.stringify(bodyData),
        method: 'POST',
        headers: Api.headers,
      }).then(res => res.json())
        .then(res => {
          resolve(res);

        })
        .catch(error => {
          reject(error);
          console.error('Error:', error)
        });
    });
  },
  getElementByBarcode: function (data) {
    const bodyData = this.getBodyWithToken(data);
    const syncUrl = "getElementByBarcode";
    return new Promise(function (resolve, reject) {
      bodyData.random = Math.random();
      fetch(Api.apiUrl + syncUrl, {
        body: JSON.stringify(bodyData),
        method: 'POST',
        headers: Api.headers,
      }).then(res => res.json())
        .then(res => {
          resolve(res);

        })
        .catch(error => {
          reject(error);
          console.error('Error:', error)
        });
    });
  },
  getElementByText: function (data) {
    const bodyData = this.getBodyWithToken(data);
    const syncUrl = "getElementByText";
    return new Promise(function (resolve, reject) {
      bodyData.random = Math.random();
      fetch(Api.apiUrl + syncUrl, {
        body: JSON.stringify(bodyData),
        method: 'POST',
        headers: Api.headers,
      }).then(res => res.json())
        .then(res => {
          resolve(res);

        })
        .catch(error => {
          reject(error);
          console.error('Error:', error)
        });
    });
  },
  sendSzamlazzHu: function (data) {
    const bodyData = this.getBodyWithToken(data);
    const syncUrl = "sendSzamlazzHu";
    return new Promise(function (resolve, reject) {
      bodyData.random = Math.random();
      fetch(Api.apiUrl + syncUrl, {
        body: JSON.stringify(bodyData),
        method: 'POST',
        headers: Api.headers,
      }).then(res => res.json())
        .then(res => {
          resolve(res);

        })
        .catch(error => {
          reject(error);
          console.error('Error:', error)
        });
    });
  },


  //
  // // Company data
  // getCompanyData: function () {
  //   const data = {
  //     data: Math.random()
  //   };
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getCompanyData";
  //   return new Promise(function (resolve, reject) {
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // saveCompanyData: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "saveCompanyData";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  //
  // // getAddress
  // getAddresses: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getAddresses";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getAddress: function (id) {
  //   const data = {
  //     id: id, data: Math.random()
  //   };
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getAddress";
  //   return new Promise(function (resolve, reject) {
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // saveAddress: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "saveAddress";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  //
  // // Contacts
  // getContacts: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getContacts";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getContact: function (id) {
  //   const data = {
  //     id: id, data: Math.random()
  //   };
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getContact";
  //   return new Promise(function (resolve, reject) {
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // saveContact: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "saveContact";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  //
  //
  // // Offer
  // getOfferLists: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getOfferLists";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getOfferList: function (id) {
  //   const data = {
  //     id: id, data: Math.random()
  //   };
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getOfferList";
  //   return new Promise(function (resolve, reject) {
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // saveOfferList: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "saveOfferList";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  //
  // getOfferListElements: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getOfferListElements";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getOfferListElement: function (id) {
  //   const data = {
  //     id: id, data: Math.random()
  //   };
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getOfferListElement";
  //   return new Promise(function (resolve, reject) {
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // saveOfferListElement: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "saveOfferListElement";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  //
  //
  // // Shop
  // getShopLists: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getShopLists";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getShopList: function (id) {
  //   const data = {
  //     id: id, data: Math.random()
  //   };
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getShopList";
  //   return new Promise(function (resolve, reject) {
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // saveShopList: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "saveShopList";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  //
  // getShopListElements: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getShopListElements";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getShopListElement: function (id) {
  //   const data = {
  //     id: id, data: Math.random()
  //   };
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getShopListElement";
  //   return new Promise(function (resolve, reject) {
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // saveShopListElement: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "saveShopListElement";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  //
  //
  // // Order
  // getOrderLists: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getOrderLists";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getOrderList: function (id) {
  //   const data = {
  //     id: id, data: Math.random()
  //   };
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getOrderList";
  //   return new Promise(function (resolve, reject) {
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // saveOrderList: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "saveOrderList";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  //
  // getOrderListElements: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getOrderListElements";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getOrderListlement: function (id) {
  //   const data = {
  //     id: id, data: Math.random()
  //   };
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getOrderListlement";
  //   return new Promise(function (resolve, reject) {
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // saveOrderListElement: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "saveOrderListElement";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  //
  //
  // // Revenue
  // getRevenueLists: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getRevenueLists";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getRevenueList: function (id) {
  //   const data = {
  //     id: id, data: Math.random()
  //   };
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getRevenueList";
  //   return new Promise(function (resolve, reject) {
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // saveRevenueList: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "saveRevenueList";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  //
  // getRevenueListElements: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getRevenueListElements";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getRevenueListElement: function (id) {
  //   const data = {
  //     id: id, data: Math.random()
  //   };
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getRevenueListElement";
  //   return new Promise(function (resolve, reject) {
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // saveRevenueListElement: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "saveRevenueListElement";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // // Revenue
  // getDeliveryNotes: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getDeliveryNotes";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getDeliveryNote: function (id) {
  //   const data = {
  //     id: id, data: Math.random()
  //   };
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getDeliveryNote";
  //   return new Promise(function (resolve, reject) {
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // saveDeliveryNote: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "saveDeliveryNote";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  //
  // getRevenues: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getRevenues";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getRevenue: function (id) {
  //   const data = {
  //     id: id, data: Math.random()
  //   };
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getRevenue";
  //   return new Promise(function (resolve, reject) {
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // saveRevenue: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "saveRevenue";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  //
  // // vat
  // getVats: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getVats";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getVat: function (id) {
  //   const data = {
  //     id: id, data: Math.random()
  //   };
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getVat";
  //   return new Promise(function (resolve, reject) {
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // saveVat: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "saveVat";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  //
  // // ListElement
  // getListElements: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getListElements";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getListElement: function (id) {
  //   const data = {
  //     id: id, data: Math.random()
  //   };
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getListElement";
  //   return new Promise(function (resolve, reject) {
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // saveListElement: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "saveListElement";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  //
  //
  // getStockAlertByElementId: function (id) {
  //   const data = {
  //     id: id, data: Math.random()
  //   };
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getStockAlertByElementId";
  //   return new Promise(function (resolve, reject) {
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getStockAlerts: function (id) {
  //   const data = {
  //     id: id, data: Math.random()
  //   };
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getStockAlerts";
  //   return new Promise(function (resolve, reject) {
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  //
  // saveStockAlerts: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "saveStockAlerts";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  //
  // getRecipesByElementId: function (id) {
  //   const data = {
  //     id: id, data: Math.random()
  //   };
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getRecipesByElementId";
  //   return new Promise(function (resolve, reject) {
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  //
  // saveRecipes: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "saveRecipes";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  //
  //
  // getWorkLogs: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getWorkLogs";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  //
  //
  // // Workstations
  // getWorkstations: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getWorkstations";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getWorkstation: function (id) {
  //   const data = {
  //     id: id, data: Math.random()
  //   };
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getWorkstation";
  //   return new Promise(function (resolve, reject) {
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // saveWorkstation: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "saveWorkstation";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getDocumentSerialNumber: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getDocumentSerialNumber";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // saveDocumentSerialNumber: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "saveDocumentSerialNumber";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  //
  // // Settings
  // getSettings: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getSettings";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // // getSetting: function (id) {
  // //   const Api = this;
  // //   const data = {
  // //     id: id, data: Math.random()
  // //   };
  // //   const bodyData = this.getBodyWithToken(data);
  // //   const syncUrl = "getSetting";
  // //   return new Promise(function (resolve, reject) {
  // //     fetch(Api.apiUrl + syncUrl, {
  // //       body: JSON.stringify(bodyData),
  // //       method: 'POST',
  // //       headers: Api.headers
  // //     }).then(res => res.json())
  // //       .then(res => {
  // //         resolve(res);
  // //
  // //       })
  // //       .catch(error => {
  // //         reject(error);
  // //         console.error('Error:', error)
  // //       });
  // //   });
  // // },
  // // saveSettings: function (data) {
  // //   const Api = this;
  // //   const bodyData = this.getBodyWithToken(data);
  // //   const syncUrl = "saveSettings";
  // //   return new Promise(function (resolve, reject) {
  // //     bodyData.random = Math.random();
  // //     fetch(Api.apiUrl + syncUrl, {
  // //       body: JSON.stringify(bodyData),
  // //       method: 'POST',
  // //       headers: Api.headers,
  // //     }).then(res => res.json())
  // //       .then(res => {
  // //         resolve(res);
  // //
  // //       })
  // //       .catch(error => {
  // //         reject(error);
  // //         console.error('Error:', error)
  // //       });
  // //   });
  // // },
  // saveSettingsMoney: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "saveSettingsMoney";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // saveSettingsLang: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "saveSettingsLang";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // cDataC: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "cDataC";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  //
  // // sid and barcode
  // getDataBySid: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getDataBySid";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  //
  // /* ProductSearcher */
  // getElementCategoriesMultiParams: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getElementCategoriesMultiParams";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getElementsByMultiParams: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getElementsByMultiParams";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  //
  // // ELEMENT_CATEGORY
  // getElementCategories: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getElementCategories";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getElementCategory: function (id) {
  //   const data = {
  //     id: id, data: Math.random()
  //   };
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getElementCategory";
  //   return new Promise(function (resolve, reject) {
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // saveElementCategory: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "saveElementCategory";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  //
  // // Buyer
  // getBuyers: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getBuyers";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getBuyer: function (id) {
  //   const data = {
  //     id: id, data: Math.random()
  //   };
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getBuyer";
  //   return new Promise(function (resolve, reject) {
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // saveBuyer: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "saveBuyer";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // // Contents
  // getContents: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getContents";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getContent: function (id) {
  //   const data = {
  //     id: id, data: Math.random()
  //   };
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getContent";
  //   return new Promise(function (resolve, reject) {
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // saveContent: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "saveContent";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // saveContentPrintBlokk: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "saveContentPrintBlokk";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  //
  //
  // fn: function (data) {
  //
  // },
  //
  // // SelDashboard queries
  // getSelDashboardData: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getSelDashboardData";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getSelStatByStore: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getSelStatByStore";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getSelStatisticData: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getSelStatisticData";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getSellDataExport: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getSellDataExport";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getSellDetailsDataExport: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getSellDetailsDataExport";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  //
  // // sell data for reports
  // /**
  //  * data contain: {from: datetime,to:datetime}
  //  * maybe another filter in the future, as "type" and "status"
  //  * @param data
  //  * @returns {Promise}
  //  */
  // getReportSellDetails: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getReportSellDetails";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // /**
  //  * data contain: {from: datetime,to:datetime}
  //  * @param data
  //  * @returns {Promise}
  //  */
  // getReportBuyers: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getReportBuyers";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // /**
  //  * data contain: {}
  //  * @param data
  //  * @returns {Promise}
  //  */
  // getReportSellerUsers: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getReportSellerUsers";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // /**
  //  *
  //  * @param data
  //  * @returns {Promise}
  //  */
  // getSells: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getSells";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },
  // getSell: function (data) {
  //   const bodyData = this.getBodyWithToken(data);
  //   const syncUrl = "getSell";
  //   return new Promise(function (resolve, reject) {
  //     bodyData.random = Math.random();
  //     fetch(Api.apiUrl + syncUrl, {
  //       body: JSON.stringify(bodyData),
  //       method: 'POST',
  //       headers: Api.headers,
  //     }).then(res => res.json())
  //       .then(res => {
  //         resolve(res);
  //
  //       })
  //       .catch(error => {
  //         reject(error);
  //         console.error('Error:', error)
  //       });
  //   });
  // },

}

export default Api;

